import React, { useEffect, useState } from 'react';
import { Button } from './ui/Button';
import { motion, useScroll, useTransform } from 'framer-motion';
export function StickyCtaBar() {
  const {
    scrollY
  } = useScroll();
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    return scrollY.onChange(latest => {
      setIsVisible(latest > 600);
    });
  }, [scrollY]);
  return <motion.div initial={{
    y: 100
  }} animate={{
    y: isVisible ? 0 : 100
  }} transition={{
    duration: 0.3
  }} className="fixed bottom-0 left-0 right-0 z-50 p-4 pointer-events-none" data-id="element-241">
      <div className="max-w-4xl mx-auto bg-[#111111]/90 backdrop-blur-lg border border-gray-800 rounded-2xl p-4 shadow-2xl flex items-center justify-between pointer-events-auto" style={{
      backgroundColor: '#121212',
      marginTop: '150px',
      marginBottom: '150px'
    }} data-id="element-242">
        <div className="hidden md:block" data-id="element-243">
          <p className="text-white font-bold" data-id="element-244">Reset Operativo (7 Min)</p>
          <p className="text-sm text-gray-400" data-id="element-245">Protocolo Anti-Estrés</p>
        </div>
        <div className="flex items-center gap-4 w-full md:w-auto" data-id="element-246">
          <span className="text-xl font-bold text-white hidden md:block" data-id="element-247">
            <span className="line-through text-gray-500 text-base mr-1" data-id="element-248">
              $27
            </span>{' '}
            $6.39
          </span>
          <Button size="md" className="w-full md:w-auto" href="https://helproutines.com/cart/44635947597894:1" data-id="element-249">
            Quiero el Reset — $6.39
          </Button>
        </div>
      </div>
    </motion.div>;
}